import TableAction from "./components/TableAction.vue";
import TableSelect from "./components/TableSelect.vue";
import TableTooltip from "./components/TableTooltip.vue";

import type { App } from "vue";

export default {
  install(app: App): void {
    app.component(TableSelect.name, TableSelect);
    app.component(TableTooltip.name, TableTooltip);
    app.component(TableAction.name, TableAction);
  }
};
